import { faPlus } from '@fortawesome/free-solid-svg-icons';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import ToggleButton from 'components/buttons/ToggleButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Collapse } from 'reactstrap';

const Toggle = ({ text, section, openSection, setOpenSection, emptyValue, children, button }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isSectionOpen = openSection === section;

    const handleToggle = (section) => {
        setOpenSection(section);

        if (navigator.userAgent.toLowerCase().includes("windows")) {
            window.location.hash = `section-${section}`;
        }
    };

    const NoDataComponent = (
        <div className="pl-2">
            <Row>
                <Col md="12" className="pt-1">
                    {emptyValue?.header}
                </Col>
            </Row>
            <Row>
                <Col md="12" className="pt-1">
                    <IconButtonWithTooltip translationId={emptyValue?.label} icon={faPlus} onClick={() => navigate(emptyValue?.link)} type="Button"/>
                </Col>
            </Row>
        </div>
    );

    return (
        <>
            {button ?
                <Row>
                    <Col md={10}>
                        <ToggleButton text={text} section={section} isSectionOpen={isSectionOpen} setOpenSection={(e) => {handleToggle(e)}} />
                    </Col>
                    <Col md={2}>
                        {button}
                    </Col>
                </Row>
            :
                <ToggleButton text={text} section={section} isSectionOpen={isSectionOpen} setOpenSection={(e) => {handleToggle(e)}} />
            }
            <Collapse id={`section-${section}`} isOpen={isSectionOpen}>
                {children || NoDataComponent}
            </Collapse>
        </>
    );
};

export default Toggle;